export const ROUTE_LICENSE_STATUS = 'licenseStatus';
export const ROUTE_LICENSE_START = 'licenseStart';
export const ROUTE_LICENSE_VERIFICATION = 'licenseVerification';
export const ROUTE_LICENSE_UPLOAD = 'licenseUpload';
